import React from "react";
import { Navbar, Image } from "react-bootstrap";
import blackLogo from "../../Assests/images/logo-border.png";
import { useNavigate } from "react-router-dom";
export default function Brandlogo({ isWhiteBg = false, history, isHome }) {
  const navigate = useNavigate();
  return (
        <div className="header-logo-setup">
          <Navbar.Brand
            onClick={() => !isHome && navigate("/")}
            className="headerv1-logo"
            aria-label={"Navigate to home"}
          >
            <div className="figure-wrapper">
              <Image
                className={`brand-logo-image`}
                alt={"brand logo"}
                src={
                    blackLogo                  
                }
              ></Image>
            </div>
          </Navbar.Brand>
        </div>
  );
}
